var $ = require('jquery');

$(function(){
  $('.js-st-Header__navBtn, .js-hs-Header__navBtn').on('click', function(){
    $('.js-st-Header__nav, .js-hs-Header__nav').stop().toggleClass('is-navshow');
  });
});